module.exports = __webpack_public_path__ + "static/media/Encomienda_Cargo_480x480px.c2d18ce8.jpg";